export default "__VITE_ASSET__DSzoFOu3__"